import styled from "styled-components";

export const Container = styled.section`
  width: min(92%, 760px);
  margin: 48px auto 64px;
  color: ${({ theme }) => theme.text};
  line-height: 1.7;

  h2 {
    margin: 0 0 12px;
    font-size: 1.45rem;
  }

  p {
    margin: 0;
    opacity: 0.88;
  }
`;

export const Section = styled.section`
  padding: 24px 0;
  border-top: 1px solid ${({ theme }) => theme.border100};
`;

export const Kicker = styled.p`
  margin-bottom: 8px;
  color: ${({ theme }) => theme.green};
  font-size: 0.85rem;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
`;

export const StepList = styled.ol`
  margin: 0;
  padding-left: 20px;

  li + li {
    margin-top: 8px;
  }
`;

export const FaqList = styled.div`
  display: grid;
  gap: 12px;

  details {
    padding: 16px;
    background: ${({ theme }) => theme.background100};
    border: 1px solid ${({ theme }) => theme.border100};
    border-radius: 8px;
  }

  summary {
    cursor: pointer;
    font-weight: 800;
  }

  p {
    margin-top: 10px;
  }
`;
